import { render, staticRenderFns } from "./ClientsDialog.vue?vue&type=template&id=938d354e"
import script from "./ClientsDialog.vue?vue&type=script&lang=js"
export * from "./ClientsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports